import { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function Forecasting() {
  const [forecastData] = useState({
    revenue: [
      { month: 'Jan', actual: 120000, forecast: 125000 },
      { month: 'Feb', actual: 130000, forecast: 135000 },
      { month: 'Mar', actual: 140000, forecast: 145000 },
      { month: 'Apr', actual: null, forecast: 155000 },
      { month: 'May', actual: null, forecast: 165000 },
      { month: 'Jun', actual: null, forecast: 175000 }
    ],
    costs: [
      { month: 'Jan', actual: 80000, forecast: 82000 },
      { month: 'Feb', actual: 85000, forecast: 87000 },
      { month: 'Mar', actual: 90000, forecast: 92000 },
      { month: 'Apr', actual: null, forecast: 97000 },
      { month: 'May', actual: null, forecast: 102000 },
      { month: 'Jun', actual: null, forecast: 107000 }
    ]
  });

  const metrics = [
    { name: 'Revenue Growth', value: '+15%', trend: 'up' },
    { name: 'Customer Acquisition', value: '+22%', trend: 'up' },
    { name: 'Marketing Efficiency', value: '3.2x', trend: 'up' },
    { name: 'Cost Growth', value: '+8%', trend: 'down' }
  ];

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-8">Forecasting</h1>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          {metrics.map((metric) => (
            <div key={metric.name} className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-sm font-medium text-gray-500">{metric.name}</h3>
              <div className="mt-2 flex items-center">
                <span className="text-2xl font-semibold text-gray-900">{metric.value}</span>
                <span className={`ml-2 ${metric.trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
                  {metric.trend === 'up' ? '↑' : '↓'}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Revenue Forecast */}
        <div className="bg-white rounded-lg p-6 shadow-sm mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Revenue Forecast</h2>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={forecastData.revenue}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="actual"
                  stroke="#4F46E5"
                  fill="#818CF8"
                  name="Actual Revenue"
                />
                <Area
                  type="monotone"
                  dataKey="forecast"
                  stroke="#9333EA"
                  fill="#C084FC"
                  name="Forecasted Revenue"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Cost Forecast */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Cost Forecast</h2>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={forecastData.costs}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="actual"
                  stroke="#DC2626"
                  fill="#FCA5A5"
                  name="Actual Costs"
                />
                <Area
                  type="monotone"
                  dataKey="forecast"
                  stroke="#EA580C"
                  fill="#FDBA74"
                  name="Forecasted Costs"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forecasting;